var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('ui-info',[_vm._v("\n      Simple info\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }